import React, { useContext } from "react";
import PropertyContext from "../contexts/PropertyContext";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Typography,
} from "@mui/material";

function SelectProperty({ properties, fallbackClientId }) {
  const { selectedProperty, setSelectedProperty } = useContext(PropertyContext);
  console.log(properties);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "80vh",
      }}
    >
      <Paper
        elevation={3}
        sx={{
          padding: "20px",
          maxWidth: 400,
          margin: "auto",
          textAlign: "center",
        }}
      >
        <Typography variant="h6" gutterBottom>
          Choose a Property
        </Typography>
        <FormControl fullWidth margin="normal">
          <InputLabel id="select-property-label">
            Please Select A Property
          </InputLabel>
          <Select
            labelId="select-property-label"
            value={selectedProperty || ""}
            label="Please Select A Property"
            onChange={(e) => {
              const picked = properties.find((p) => p.id === e.target.value);
              // Fall back to the user's own clientId when the property entry
              // predates the properties-under-clients migration backfill —
              // every property a user has belongs to their own client.
              setSelectedProperty(
                e.target.value,
                picked?.clientId || fallbackClientId,
              );
            }}
          >
            {properties.map((property, index) => (
              <MenuItem key={index} value={property.id}>
                {property.displayName || property.name || property.id}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Paper>
    </Box>
  );
}

export default SelectProperty;
